import React, { FC } from "react";
import { Controls3 } from "@ews/react-data";
import s from "../SystemDocumentation.module.scss";
import { DisplaySettings } from "@ews/react-data";

const TableControls3: FC<{
  data: Controls3;
  displaySettings: DisplaySettings;
}> = ({ data, displaySettings }) =>
  {
    if (!data) return <>no data</>;

    // [TM, StörAlarm]
    const activeCols =
      3 +
      Number(displaySettings.displayTechnicalMessage ? 1 : 0) +
      Number(displaySettings.displayPreAlarm ? 1 : 0) +
      Number(displaySettings.displayFaultAlarm ? 1 : 0);

    // Total available width for dynamic cols = 5 * 48 = 240px
    const colWidth = 240 / activeCols;

    return (
      <table
        id="system-documentation-controls3"
        data-name="Steuerungen3"
        className={s.table}
      >
        <thead>
          <tr>
            <th style={{ width: "210px" }}></th>
            <th style={{ width: "420px" }}></th>
            {/* <th style={{ width: `${colWidth}px` }}></th>
                    {displaySettings.displayTechnicalMessage && <th style={{ width: `${colWidth}px` }}></th>}
                    {displaySettings.displayFaultAlarm && <th style={{ width: `${colWidth}px` }}></th>}
                    <th style={{ width: `${colWidth}px` }}></th>
                    <th style={{ width: `${colWidth}px` }}></th> */}

            {Array.from({ length: activeCols }).map((_, i) => (
              <th key={i} style={{ width: `${colWidth}px` }}></th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={2}>
              Brandmeldeanlage
            </td>
            <td className={`${s.b} ${s.title}`} colSpan={activeCols}>
              TRVB 123 S
            </td>
          </tr>

          <tr>
            <td
              className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`}
              rowSpan={2}
              colSpan={2}
            >
              Steuerungen (Unterlagen für Betreiber)
            </td>
            <td className={`${s.bR} ${s.title}`} colSpan={activeCols}>
              Anhang 1
            </td>
          </tr>
          <tr>
            <td className={`${s.bR} ${s.title}`} colSpan={activeCols}>
              StGV 3
            </td>
          </tr>

          <tr>
            <td rowSpan={2} className={`${s.bold} ${s.b} ${s.aT} ${s.tC}`}>
              BG/ Steuergruppennummern/ Eingangsnr.
            </td>
            <td rowSpan={2} className={`${s.bold} ${s.b} ${s.aT} ${s.tC}`}>
              Bezeichnung BG/ Bezeichnung STG
            </td>
            <td colSpan={activeCols} className={`${s.b} ${s.aT} ${s.tC}`}>
              angesteuert bei
            </td>
          </tr>
          <tr>
            <td className={`${s.vertical} ${s.b} ${s.aM} ${s.tC}`}>Alarm</td>
            {displaySettings.displayPreAlarm && (
              <td className={`${s.vertical} ${s.b} ${s.aM} ${s.tC}`}>PreAlarm</td>
            )}
            {displaySettings.displayTechnicalMessage && (
              <td className={`${s.vertical} ${s.b} ${s.aM} ${s.tC}`}>TM</td>
            )}
            {displaySettings.displayFaultAlarm && (
              <td className={`${s.vertical} ${s.b} ${s.aM} ${s.tC}`}>
                StörAlarm
              </td>
            )}
            <td className={`${s.vertical} ${s.b} ${s.aM} ${s.tC}`}>Stör.</td>
            <td className={`${s.vertical} ${s.b} ${s.aM} ${s.tC}`}>Abs.</td>
          </tr>

          {/* OR Section */}
          <tr>
            <td colSpan={activeCols + 2} className={`${s.b} ${s.aT} ${s.tL}`}>
              ODER-Verknüpfung
            </td>
          </tr>
          {Object.values(data.Or).map((value, idx) => (
            <React.Fragment key={`or-${idx}`}>
              <tr className={s.greyRow}>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>{value.zone.title}</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>
                  {value.zone.description}
                </td>
                {Array.from({ length: activeCols }).map((_, i) => (
                  <td key={i} className={`${s.b} ${s.aT} ${s.tL}`}></td>
                ))}
              </tr>
              {value.activations.map((item, aIdx) => (
                <tr key={`or-act-${idx}-${aIdx}`}>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>
                    {item.groupElement}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.description}</td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Alarm"] ? "X" : ""}
                  </td>
                  {displaySettings.displayPreAlarm && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["PreAlarm"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayTechnicalMessage && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["TechnicalMessage"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayFaultAlarm && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["FaultAlarm"] ? "X" : ""}
                    </td>
                  )}
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Fault"] ? "X" : ""}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Shutdown"] ? "X" : ""}
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}

          {/* AND Section */}
          <tr>
            <td colSpan={activeCols + 2} className={`${s.b} ${s.aT} ${s.tL}`}>
              UND-Verknüpfung
            </td>
          </tr>
          {Object.values(data.And).map((value, idx) => (
            <React.Fragment key={`and-${idx}`}>
              <tr className={s.greyRow}>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>{value.zone.title}</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>
                  {value.zone.description}
                </td>
                {Array.from({ length: activeCols }).map((_, i) => (
                  <td key={i} className={`${s.b} ${s.aT} ${s.tL}`}></td>
                ))}
              </tr>
              {value.activations.map((item, aIdx) => (
                <tr key={`and-act-${idx}-${aIdx}`}>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>
                    {item.groupElement}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.description}</td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Alarm"] ? "X" : ""}
                  </td>
                  {displaySettings.displayPreAlarm && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["PreAlarm"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayTechnicalMessage && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["TechnicalMessage"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayFaultAlarm && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["FaultAlarm"] ? "X" : ""}
                    </td>
                  )}
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Fault"] ? "X" : ""}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Shutdown"] ? "X" : ""}
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}

          {/* 2Group Section */}
          <tr>
            <td colSpan={activeCols + 2} className={`${s.b} ${s.aT} ${s.tL}`}>
              2-Gruppen-Aktivierung
            </td>
          </tr>
          {Object.values(data["2Group"]).map((value, idx) => (
            <React.Fragment key={`2group-${idx}`}>
              <tr className={s.greyRow}>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>{value.zone.title}</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>
                  {value.zone.description}
                </td>
                {Array.from({ length: activeCols }).map((_, i) => (
                  <td key={i} className={`${s.b} ${s.aT} ${s.tL}`}></td>
                ))}
              </tr>
              {value.activations.map((item, aIdx) => (
                <tr key={`2group-act-${idx}-${aIdx}`}>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>
                    {item.groupElement}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.description}</td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Alarm"] ? "X" : ""}
                  </td>
                  {displaySettings.displayTechnicalMessage && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["PreAlarm"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayTechnicalMessage && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["TechnicalMessage"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayFaultAlarm && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["FaultAlarm"] ? "X" : ""}
                    </td>
                  )}
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Fault"] ? "X" : ""}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Shutdown"] ? "X" : ""}
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}

          {/* 2Element Section */}
          <tr>
            <td colSpan={activeCols + 2} className={`${s.b} ${s.aT} ${s.tL}`}>
              2-Element-Aktivierung
            </td>
          </tr>
          {Object.values(data["2Element"]).map((value, idx) => (
            <React.Fragment key={`2element-${idx}`}>
              <tr className={s.greyRow}>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>{value.zone.title}</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>
                  {value.zone.description}
                </td>
                {Array.from({ length: activeCols }).map((_, i) => (
                  <td key={i} className={`${s.b} ${s.aT} ${s.tL}`}></td>
                ))}
              </tr>
              {value.activations.map((item, aIdx) => (
                <tr key={`2element-act-${idx}-${aIdx}`}>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>
                    {item.groupElement}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.description}</td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Alarm"] ? "X" : ""}
                  </td>
                  {displaySettings.displayTechnicalMessage && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["PreAlarm"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayTechnicalMessage && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["TechnicalMessage"] ? "X" : ""}
                    </td>
                  )}
                  {displaySettings.displayFaultAlarm && (
                    <td className={`${s.b} ${s.aT} ${s.tC}`}>
                      {item.controlType["FaultAlarm"] ? "X" : ""}
                    </td>
                  )}
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Fault"] ? "X" : ""}
                  </td>
                  <td className={`${s.b} ${s.aT} ${s.tC}`}>
                    {item.controlType["Shutdown"] ? "X" : ""}
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    );
  };

export default TableControls3;
